"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyPhaseDisp = exports.StudyPhase = void 0;
var StudyPhase;
(function (StudyPhase) {
    StudyPhase["PHASE_1"] = "PHASE_1";
    StudyPhase["PHASE_1_2"] = "PHASE_1_2";
    StudyPhase["PHASE_2"] = "PHASE_2";
    StudyPhase["PHASE_3"] = "PHASE_3";
    StudyPhase["PHASE_4"] = "PHASE_4";
    StudyPhase["IIT"] = "IIT";
    StudyPhase["PMS"] = "PMS";
    StudyPhase["OS"] = "OS";
    StudyPhase["BE"] = "BE";
    StudyPhase["PILOT"] = "PILOT";
    StudyPhase["MD_IND"] = "MD_IND";
    StudyPhase["MD_NON_IND"] = "MD_NON_IND";
    StudyPhase["FNS_IND"] = "FNS_IND";
    StudyPhase["FNS_NON_IND"] = "FNS_NON_IND";
    StudyPhase["REGISTRY"] = "REGISTRY";
    StudyPhase["R_PMS"] = "R_PMS";
    StudyPhase["RWE"] = "RWE";
    StudyPhase["PIVOTAL"] = "PIVOTAL";
    StudyPhase["RESEARCH"] = "RESEARCH";
    StudyPhase["MARKETING"] = "MARKETING";
    StudyPhase["POST_MARKET"] = "POST_MARKET";
    StudyPhase["BDD"] = "BDD";
    StudyPhase["OTHER"] = "OTHER";
})(StudyPhase = exports.StudyPhase || (exports.StudyPhase = {}));
exports.StudyPhaseDisp = {
    [StudyPhase.PHASE_1]: {
        en: "Phase 1",
        ko: "1 상",
    },
    [StudyPhase.PHASE_1_2]: {
        en: "Phase 1 & 2",
        ko: "1 & 2 상",
    },
    [StudyPhase.PHASE_2]: {
        en: "Phase 2",
        ko: "2 상",
    },
    [StudyPhase.PHASE_3]: {
        en: "Phase 3",
        ko: "3 상",
    },
    [StudyPhase.PHASE_4]: {
        en: "Phase 4",
        ko: "4 상",
    },
    [StudyPhase.IIT]: {
        en: "Investigator Initiated Trial",
        ko: "연구자 주도 임상",
    },
    [StudyPhase.PMS]: {
        en: "PMS (Post Market Surveillance)",
        ko: "사용 성적 조사",
    },
    [StudyPhase.OS]: {
        en: "Observation Study",
        ko: "관찰 연구",
    },
    [StudyPhase.BE]: {
        en: "Bioequivalence",
        ko: "생물학적 동등성 시험",
    },
    [StudyPhase.PILOT]: {
        en: "Pilot",
        ko: "Pilot",
    },
    [StudyPhase.MD_IND]: {
        en: "Medical Device - IND",
        ko: "의료기기 (IND)",
    },
    [StudyPhase.MD_NON_IND]: {
        en: "Medical Device - Non-IND",
        ko: "의료기기 (Non IND)",
    },
    [StudyPhase.FNS_IND]: {
        en: "Food & Supplementary - IND",
        ko: "건강기능식품 (IND)",
    },
    [StudyPhase.FNS_NON_IND]: {
        en: "Food & Supplementary - Non-IND",
        ko: "건강기능식품 (Non IND)",
    },
    [StudyPhase.REGISTRY]: {
        en: "Registry",
        ko: "Registry",
    },
    [StudyPhase.R_PMS]: {
        en: "r-PMS",
        ko: "r-PMS",
    },
    [StudyPhase.RWE]: {
        en: "RWE Study",
        ko: "RWE Study",
    },
    [StudyPhase.PIVOTAL]: {
        en: "Pivotal",
        ko: "확증 임상시험",
    },
    [StudyPhase.RESEARCH]: {
        en: "Research",
        ko: "연구용 임상시험",
    },
    [StudyPhase.MARKETING]: {
        en: "Marketing",
        ko: "마케팅용 임상시험",
    },
    [StudyPhase.POST_MARKET]: {
        en: "Post-Market Clinical Trial",
        ko: "허가 후 임상시험",
    },
    [StudyPhase.BDD]: {
        en: "BDD Clinical Trial",
        ko: "혁신의료기술/기기",
    },
    [StudyPhase.OTHER]: {
        en: "Other",
        ko: "Other",
    },
};
//# sourceMappingURL=study.js.map